import Collapsible from '../Collapsible';

import picure1 from '../../assets/images/MeasurmentProcedure/Picture1.png';
import picure2 from '../../assets/images/MeasurmentProcedure/Picture2.png';
import picure3 from '../../assets/images/MeasurmentProcedure/Picture3.png';
import picure4 from '../../assets/images/MeasurmentProcedure/Picture4.png';
import proceduraPomiaru from '../../assets/images/MeasurmentProcedure/proceduraPomiaru2.png';
import raportDekra from '../../assets/files/RaportDekra.pdf';
import './index.scss';
import scrollMeTo from '../../helpers/scrollMeTo';

export const QandA = () => {
  return (
    // @ts-ignore
    <div className='q-and-a' name='questionsAndAnswers'>
      <div className='container'>
        <div className='title q-and-a__title'>PYTANIA I ODPOWIEDZI</div>
        <div className='q-and-a__question-section'>
          <Collapsible title='Co to jest test DEKRA baterii pojazdów elektrycznych/hybrydowych?'>
            Test DEKRA baterii jest prosta i szybką (około 10 min.) metodą pozwalającą miarodajnie określić kondycje baterii określając tzw. Wskaźnik Pozostałej Pojemności (SoH) w oparciu o dane uzyskane z BMS pojazdu(Battery Management System -system zarządzania baterią)
            <br />
            Od pojemności baterii zależy zasięg pojazdu oraz jego wartość rynkowa.
            <br />
            Wynikiem testu DEKRA baterii jest raport PDF zawierający określenie Wskaźnika Pozostałej Pojemności (SoH)
          </Collapsible>
          <Collapsible title='Jak przebiega pomiar kondycji baterii'>
            <div>
              <div className='q-and-a__procedures'>
                <p className='procedures-title'>Procedura pomiaru</p>
                <img
                  className='procedures-image'
                  src={proceduraPomiaru}
                  alt='procedura pomiaru'
                />
                <div style={{ display: 'flex' }}>
                  <div className='procedures-item'>
                    Połączenie testera DEKRA z portem OBDI pojazdu oraz połączenie z aplikacją DEKRA na smartfonie eksperta DEKRA.
                  </div>
                  <div className='procedures-item'>
                    Odczyt danych diagnostycznych z BMS pojazdu.
                  </div>
                  <div className='procedures-item'>
                    Bezpośrednio po zakończeniu pomiaru na ekranie smartfonu eksperta DEKRA wyświetlany jest wynik badania. Raport z pomiaru przesyłany jest na w formacje PDF na email Klienta.
                  </div>
                </div>
              </div>
              {
                'Warunki niezbędne do przeprowadzenia testu DEKRA baterii: stan naładowania baterii od 40% do 80%, temperatura ogniw od +10°C do +30°C, odchylenie temperatur ogniw <2°C, brak krytycznych błędów baterii - sprawdzane podczas testu statycznego.Do próby przyspieszenia potrzebny jest ok. 100 metrowy odcinek utwardzonej płaskiej powierzchni, na której można bezpiecznie rozpędzić pojazd do prędkości ok. 50 km/h. Nawierzchnia nie jest śliska (np. oblodzenie) i nie występują intensywne opady deszczu, śniegu, etc.'
              }
            </div>
          </Collapsible>
          <Collapsible title='Czy można sprawdzić w DEKRA stan baterii każdego samochodu?'>
            Test DEKRA baterii nie obejmuje jeszcze wszystkich pojazdów, gdyż
            dla każdego modelu i pojemności baterii niezbędne jest
            przeprowadzenie osobnej procedury parametryzacji w DEKRA Technology
            Center. Lista możliwych do sprawdzenia pojazdów znajduje się na{' '}
            <a href='https://test-baterii.dekra.pl/'>
              {' www.test-baterii.dekra.pl'}
            </a>{' '}
            i jest stale uzupełniana.
          </Collapsible>
          <Collapsible title='Jak wygląda przykładowy raport z testu baterii DEKRA'>
            <a target="_blank" href={raportDekra}>
              <span style={{ textDecoration: 'underline' }}>
                Raport z testu DEKRA
              </span>
            </a>{' '}
            jest dostarczany w formie pliku pdf i zawiera odczytany Wskaźnik
            Pozostałej Pojemności (SoH), pojemność nominalną baterii trakcyjnej
            oraz napięcie i temperaturę ogniw, a także dane identyfikacyjne
            pojazdu: markę, model, numer identyfikacyjny pojazdu, datę 1.
            rejestracji oraz przebieg. Raport jest dostępny bezpośrednio po
            dokonaniu pomiarów.
          </Collapsible>
          <Collapsible title='Jaka jest cena testu DEKRA baterii?'>
            Test DEKRA baterii kosztuje 299 zł (brutto). Kwota obejmuje
            przeprowadzenie testu DEKRA baterii, raport PDF z badania oraz koszt
            dojazdu.
          </Collapsible>
          <button
            className='button'
            onClick={() => {
              scrollMeTo('selector');
            }}
          >
            Zamów test baterii
          </button>
        </div>
      </div>
    </div>
  );
};

export default QandA;
